module.exports = __webpack_public_path__ + "img/two-group-unpaired.6fc14ac0.svg";